// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"f70e1fb3","310":"b91bc0a9","336":"3ba44fcf","578":"4e83ff6e"}[chunkId] + ".chunk.css";
};